import React from 'react'
import get from 'lodash/get'
import { Link } from 'gatsby'
import { isExternalUrlOrHash, contentfulMapToLocalized, createWidthHopsForImage } from "../../helpers.js"

class Image extends React.Component {
  constructor(props) {
    super(props);
    const node = this.props.node
    const asset = contentfulMapToLocalized(node.fields)
    const widths = createWidthHopsForImage(asset.file.details.image)
    let sizes = [], srcSet = []
    const widthsLength = widths.length;
    widths.forEach((width, index) => {
      srcSet.push(`${asset.file.url}?w=${width}&fit=scale`)

      if (index === widthsLength - 1) {
        //We don't want to specify a `max-size` for the bigger size
        sizes.push(`${width}`)
      } else {
        sizes.push(`(max-width: ${width}) ${width}`)
      }
    })
    this.imageAttrs = {
      'data-sizes': sizes.join(', '),
      'data-srcset': srcSet.reverse().join(', '),
      'data-src': `${asset.file.url}?fm=jpg&fl=progressive`,
      alt: asset.description || asset.title,
      className: 'img-fluid lazyload'
    }
    this.containerClassName = `image-container mx-auto my-5 ${this.props.className ? this.props.className : ''}`
  }
  render() {
    return (
      <div className={ this.containerClassName }>
        <img { ...this.imageAttrs }/>
      </div>
    )
  }
}

export default Image
